import React, { useEffect, useState } from 'react';
import { Tr, Td } from "react-super-responsive-table"
import {Col,Row,Card,CardBody, Button} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import imgdark from "../../assets/images/logo-dark.png";
import { RingLoader, PulseLoader, BarLoader } from "react-spinners";
import * as url from "./../../helpers/url_helper"
import moment from "moment"
const PrintBord = (props) => {
    document.title = "Bordereau | Impression de bordereau";
    const breadcrumbItems = [{ title: "Lexa", link: "#" }, { title: "Pages", link: "#" }, { title: "Invoice", link: "#" },]
    useEffect(() => { props.setBreadcrumbItems('Invoice', breadcrumbItems); loadOperations() }, [])
    const printInvoice = () => { window.print() }
    let [loadingOps, setLoadingOps] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { bordereau } = location.state || {};
    const [operations, setOperations] = useState([]);

    const loadOperations=()=> { 
        setLoadingOps(true);
        fetch(url.BACKEND_URL+"/operation?size=50&bord="+bordereau.bordId, {
          method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
        .then((response) => response.json())
        .then((responseJson) => { console.log(responseJson.data);
          if (responseJson.status==200) { 
            setOperations(responseJson.data)
            setLoadingOps(false);
        } else {  }
        }) .catch((error) => {  });
      };
    return (
        <React.Fragment>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardBody>

                            <Row>
                                <Col xs="12">
                                    <div className="invoice-title">
                                        <h4 className="float-end font-size-16"><strong>Bordereau # {bordereau.bordCode}</strong></h4>
                                        <h3>
                                            <img src={imgdark} alt="logo" height="24" />
                                        </h3>
                                    </div>
                                    <hr />
                                    <Row>
                                        <Col xs="6">
                                            <address>
                                                <strong>Créé par:</strong><br />
                                                {bordereau.bordUser.usNom}<br/>
                                                {bordereau.bordAgexp.agNom}<br/>
                                            </address>
                                        </Col>
                                        <Col xs="6" className="text-end">
                                            <address>
                                                <strong>Destination:</strong><br />
                                                {bordereau.bordAgdest.agNom}
                                            </address>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="6" className="mt-4"></Col>
                                        <Col xs="6" className="mt-4 text-end">
                                            <address>
                                                <strong>Créé le:</strong><br />
                                                {moment(bordereau.bordCreate).format("DD-MM-YYYY HH:mm:ss")}
                                            </address>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs="12">
                                    <div>
                                        <div className="p-2">
                                            <h3 className="font-size-16"><strong>Détails</strong></h3>
                                        </div>
                                        <div>
                                        {loadingOps ? (<BarLoader width={"100%"} height={6}/>): null}
                                        </div>
                                        <div className="">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <td><strong>Code</strong></td>
                                                            <td><strong>Date Création</strong></td>
                                                            <td><strong>Origine/Destination</strong></td>
                                                            <td><strong>Heure Exp./ Car</strong></td>
                                                            <td><strong>Expéditeur</strong></td>
                                                            <td><strong>Bénéficiaire</strong></td>
                                                            <td><strong>Valeur</strong></td>
                                                            <td><strong>Frais</strong></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {operations.map((item, key)=>(
                                                        <Tr>
                                                            <Td>{item.opCode} <br/> {item.detail[0].opdEmbal.embalLibelle}, {item.detail[0].opdNature.natLibelle}</Td>
                                                            <Td>{moment(item.opCreate).format("DD-MM-YY HH:mm:ss")}</Td>
                                                            <Td><strong>{item.opAgexp.agNom} {"==>"} {item.opAgdest.agNom}</strong></Td>
                                                            <Td>{item.opBord.bordCar ? moment(item.opBord.bordHeure).format("HH:mm") +"/Car N°_"+item.opBord.bordCar: null}</Td>
                                                            <Td>{item.opExp} ({item.opPhonexp})</Td>
                                                            <Td>{item.opDest} ({item.opDestphone})</Td>
                                                            <Td>{item.opValeur} FCFA</Td>
                                                            <Td>{item.opFrais} FCFA</Td>
                                                        </Tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="d-print-none">
                                                <div className="float-end">
                                                    <Link to="#" onClick={printInvoice} className="btn btn-success waves-effect waves-light me-2">Imprimer <i className="fa fa-print"></i></Link>{" "}
                                                    {/* <Link to="#" className="btn btn-primary waves-effect waves-light">Send</Link> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default connect(null, { setBreadcrumbItems })(PrintBord);